export const MAX_ALLOWED_ORDERS_PER_BATCH = 1200;
export const MAX_ALLOWED_NUMBER_OF_ORDERS = 50000;
export const MAX_ALLOWED_NUMBER_OF_BATCHES = 5000;

export const BATCH_BY_ORDER_COUNT = 'BATCH_BY_ORDER_COUNT';
export const BATCH_BY_BATCH_COUNT = 'BATCH_BY_BATCH_COUNT';
